// Rolling evergreen countdown (Marika quantity-discount promo).
// Counts down from `data-duration-hours`, persists its start time in
// localStorage per section instance, and restarts automatically at zero —
// ports the same pattern the original React ServiceAndOfferSection used.
(function () {
  function tick(root) {
    var durationMs = Number(root.dataset.durationHours || 71) * 60 * 60 * 1000;
    var storageKey = root.dataset.storageKey || 'marika-countdown';
    var start = Number(window.localStorage.getItem(storageKey));

    if (!start || Number.isNaN(start)) {
      start = Date.now();
      window.localStorage.setItem(storageKey, String(start));
    }

    var remaining = start + durationMs - Date.now();
    if (remaining <= 0) {
      start = Date.now();
      window.localStorage.setItem(storageKey, String(start));
      remaining = durationMs;
    }

    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    var dayEl = root.querySelector('[data-countdown-days]');
    var hourEl = root.querySelector('[data-countdown-hours]');
    var minuteEl = root.querySelector('[data-countdown-minutes]');
    var secondEl = root.querySelector('[data-countdown-seconds]');

    if (dayEl) dayEl.textContent = String(days).padStart(2, '0');
    if (hourEl) hourEl.textContent = String(hours).padStart(2, '0');
    if (minuteEl) minuteEl.textContent = String(minutes).padStart(2, '0');
    if (secondEl) secondEl.textContent = String(seconds).padStart(2, '0');
  }

  function init() {
    var roots = document.querySelectorAll('[data-marika-countdown]');
    roots.forEach(function (root) {
      tick(root);
      window.setInterval(function () {
        tick(root);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
